import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-66051b3a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "prize-manage"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("导入");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_8 = {
  class: "price-cell"
};
const _hoisted_9 = {
  key: 1,
  class: "record-empty"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("新增数量");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("扣减数量");

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 请下载Excel模板，填写团队名称、业务员名称、商品编码、奖品数量、奖品价格、效期类型、自定义时间后上传。", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 团队名称、业务员名称、商品编码、奖品数量、奖品价格、效期类型均为必填；奖品数量、奖品价格必须大于0，导入不允许负数扣减（扣减请用列表「扣减数量」）。", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 效期类型填写：1-长期有效；2-30日；3-60日；4-90日；5-自定义。类型为5时「自定义时间」必填（yyyy-MM-dd）。", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4. 业务员须属于对应团队，商品须属于对应团队可售范围。", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5. 一次最多导入500条数据。", -1));

import { onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { deletePrizeManage, exportForAsync, getPrizeManageList, getLevelOneSupplierList } from '@/request';
import { exportPrizeManageList, importPrizeManage, importPrizeManageExcel } from '@/request/api';
import { getVexTableProps } from '@/config';
import UploadModal from '@/components/UploadModal.vue';
import AddPrizeModal from './components/AddPrizeModal.vue';
import AddPrizeCountModal from './components/AddPrizeCountModal.vue';
import DeductPrizeCountModal from './components/DeductPrizeCountModal.vue';
import PrizeExpireDetailModal from './components/PrizeExpireDetailModal.vue';
import EditPrizePriceModal from './components/EditPrizePriceModal.vue';
import PrizeEditRecordModal from './components/PrizeEditRecordModal.vue';
export default {
  name: 'index',

  setup(__props) {
    const table = ref(null);
    const supplierOptions = ref([]);
    const dataTotal = ref(0);
    const showUploadModel = ref(false);
    const uploadOption = {
      action: importPrizeManage.url,
      name: 'prizeExcel',
      templateLink: importPrizeManageExcel.url,
      title: '导入'
    };
    const form = reactive({
      supplierId: '',
      salesmanKeyword: '',
      prodName: '',
      prodNo: '',
      leftNumberType: ''
    });
    const addCountModal = reactive({
      visible: false,
      row: null
    });
    const deductCountModal = reactive({
      visible: false,
      row: null
    });
    const expireDetailModal = reactive({
      visible: false,
      row: null
    });
    const addPrizeModalVisible = ref(false);
    const editPriceModal = reactive({
      visible: false,
      row: null
    });
    const recordModal = reactive({
      visible: false,
      row: null
    });

    function loadSupplierOptions() {
      getLevelOneSupplierList().then(res => {
        supplierOptions.value = (res === null || res === void 0 ? void 0 : res.data) || [];
      });
    }

    function resetHandle() {
      var _table$value;

      form.supplierId = '';
      form.salesmanKeyword = '';
      form.prodName = '';
      form.prodNo = '';
      form.leftNumberType = '';
      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    }

    function formatPrice(price) {
      if (price === null || price === undefined || price === '') {
        return '-';
      }

      return Number(price).toFixed(2);
    }

    function openAddCountModal(row) {
      addCountModal.row = row;
      addCountModal.visible = true;
    }

    function openDeductCountModal(row) {
      deductCountModal.row = row;
      deductCountModal.visible = true;
    }

    function openExpireDetailModal(row) {
      expireDetailModal.row = row;
      expireDetailModal.visible = true;
    }

    function openEditPriceModal(row) {
      editPriceModal.row = row;
      editPriceModal.visible = true;
    }

    function handleEditPriceSuccess() {
      var _table$value2;

      (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.commitProxy('reload');
    }

    function openRecordModal(row) {
      recordModal.row = row;
      recordModal.visible = true;
    }

    function handleAddCountSuccess() {
      var _table$value3;

      (_table$value3 = table.value) === null || _table$value3 === void 0 ? void 0 : _table$value3.commitProxy('reload');
    }

    function handleDeductCountSuccess() {
      var _table$value4;

      (_table$value4 = table.value) === null || _table$value4 === void 0 ? void 0 : _table$value4.commitProxy('reload');
    }

    function handleAddPrizeSuccess() {
      var _table$value5;

      (_table$value5 = table.value) === null || _table$value5 === void 0 ? void 0 : _table$value5.commitProxy('reload');
    }

    function handleImportSuccess() {
      var _table$value6;

      (_table$value6 = table.value) === null || _table$value6 === void 0 ? void 0 : _table$value6.commitProxy('reload');
    }

    function exportFile() {
      const payload = _objectSpread({}, form);

      if (!payload.supplierId) {
        delete payload.supplierId;
      }

      if (!payload.salesmanKeyword) {
        delete payload.salesmanKeyword;
      }

      if (!payload.prodName) {
        delete payload.prodName;
      }

      if (!payload.prodNo) {
        delete payload.prodNo;
      }

      if (!payload.leftNumberType) {
        delete payload.leftNumberType;
      }

      exportForAsync(_objectSpread(_objectSpread({
        __repeat: true,
        __warn: true
      }, payload), {}, {
        modularflag: 'prizeManageList',
        fileName: '业务员奖品列表',
        count: dataTotal.value,
        methodName: exportPrizeManageList.url
      }));
    }

    function handleDelete() {
      var _table$value7;

      const selectRows = ((_table$value7 = table.value) === null || _table$value7 === void 0 ? void 0 : _table$value7.getCheckboxRecords()) || [];

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作');
        return;
      }

      ElMessageBox.confirm(`确定删除选中的 ${selectRows.length} 条奖品记录吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        deletePrizeManage({
          merchandiseCansaleIds: selectRows.map(item => item.merchandiseCansaleId),
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            var _table$value8;

            ElMessage.success(data.msg || '操作成功');
            (_table$value8 = table.value) === null || _table$value8 === void 0 ? void 0 : _table$value8.commitProxy('reload');
          }
        });
      });
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return !!row.merchandiseCansaleId;
        }

      },
      columns: [{
        type: 'checkbox',
        width: 50,
        fixed: 'left'
      }, {
        title: '业务员名称',
        field: 'linkMan',
        width: 120,
        showOverflow: true
      }, {
        title: '联系方式',
        field: 'linkPhone',
        width: 120,
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        width: 160,
        showOverflow: true
      }, {
        title: '商品编码',
        field: 'prodNo',
        width: 140,
        showOverflow: true
      }, {
        title: '商品名称',
        field: 'prodName',
        minWidth: 180,
        showOverflow: true
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: 140,
        showOverflow: true
      }, {
        title: '厂家',
        field: 'manufacturer',
        width: 160,
        showOverflow: true
      }, {
        title: '奖品价格',
        field: 'price',
        width: 130,
        slots: {
          default: 'price'
        }
      }, {
        title: '当前可购数量',
        field: 'leftNumberStr',
        width: 120,
        slots: {
          default: 'leftNumber'
        }
      }, {
        title: '已购数量',
        field: 'depositStorageNumberStr',
        width: 100
      }, {
        title: '过期数量',
        field: 'expiredNumberStr',
        width: 100
      }, {
        title: '最近新增数量',
        field: 'lastAddNumberStr',
        width: 120
      }, {
        title: '最近更新人',
        field: 'updateBy',
        width: 120,
        showOverflow: true
      }, {
        title: '更新时间',
        field: 'updateTime',
        width: 160
      }, {
        title: '操作记录',
        field: 'editRecordCount',
        width: 90,
        align: 'center',
        slots: {
          default: 'editRecordCount'
        }
      }, {
        title: '操作',
        field: 'operation',
        width: 180,
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getPrizeManageList({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: form.supplierId || undefined,
              salesmanKeyword: form.salesmanKeyword || undefined,
              prodName: form.prodName || undefined,
              prodNo: form.prodNo || undefined,
              leftNumberType: form.leftNumberType || undefined,
              __warn: true
            }).then(data => {
              dataTotal.value = data.total || 0;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    onMounted(() => {
      loadSupplierOptions();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "团队"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.supplierId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.supplierId = $event),
            placeholder: "全部",
            clearable: "",
            filterable: "",
            style: {
              "width": "200px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.supplierId,
                label: item.supplierName,
                value: item.supplierId
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "业务员"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.salesmanKeyword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.salesmanKeyword = $event),
            placeholder: "账号/姓名",
            clearable: "",
            style: {
              "width": "160px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "商品名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.prodName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.prodName = $event),
            placeholder: "请输入商品名称",
            clearable: "",
            style: {
              "width": "160px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "商品编码"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.prodNo,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.prodNo = $event),
            placeholder: "请输入商品编码",
            clearable: "",
            style: {
              "width": "160px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "可购数量"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.leftNumberType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.leftNumberType = $event),
            placeholder: "全部",
            clearable: "",
            style: {
              "width": "140px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "大于0",
              value: "gt0"
            }), _createVNode(_component_el_option, {
              label: "等于0",
              value: "eq0"
            }), _createVNode(_component_el_option, {
              label: "小于0",
              value: "lt0"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_button, {
            icon: "Refresh",
            onClick: resetHandle
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[6] || (_cache[6] = $event => addPrizeModalVisible.value = true)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Upload",
          onClick: _cache[7] || (_cache[7] = $event => showUploadModel.value = true)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Download",
          onClick: exportFile
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          onClick: handleDelete
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        price: _withCtx(({
          row
        }) => [_createElementVNode("span", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(formatPrice(row.price)), 1), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          icon: "Edit",
          onClick: $event => openEditPriceModal(row)
        }, null, 8, ["onClick"])])]),
        leftNumber: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          class: "record-link",
          onClick: $event => openExpireDetailModal(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.leftNumberStr), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        editRecordCount: _withCtx(({
          row
        }) => [row.editRecordCount > 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          type: "primary",
          class: "record-link",
          onClick: $event => openRecordModal(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.editRecordCount), 1)]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_9, "0"))]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => openAddCountModal(row)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => openDeductCountModal(row)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(AddPrizeCountModal, {
        modelValue: addCountModal.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => addCountModal.visible = $event),
        row: addCountModal.row,
        onSuccess: handleAddCountSuccess
      }, null, 8, ["modelValue", "row"]), _createVNode(DeductPrizeCountModal, {
        modelValue: deductCountModal.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => deductCountModal.visible = $event),
        row: deductCountModal.row,
        onSuccess: handleDeductCountSuccess
      }, null, 8, ["modelValue", "row"]), _createVNode(PrizeExpireDetailModal, {
        modelValue: expireDetailModal.visible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => expireDetailModal.visible = $event),
        row: expireDetailModal.row
      }, null, 8, ["modelValue", "row"]), _createVNode(AddPrizeModal, {
        modelValue: addPrizeModalVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => addPrizeModalVisible.value = $event),
        "supplier-options": supplierOptions.value,
        onSuccess: handleAddPrizeSuccess
      }, null, 8, ["modelValue", "supplier-options"]), _createVNode(EditPrizePriceModal, {
        modelValue: editPriceModal.visible,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => editPriceModal.visible = $event),
        row: editPriceModal.row,
        onSuccess: handleEditPriceSuccess
      }, null, 8, ["modelValue", "row"]), _createVNode(PrizeEditRecordModal, {
        modelValue: recordModal.visible,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => recordModal.visible = $event),
        row: recordModal.row
      }, null, 8, ["modelValue", "row"]), _createVNode(UploadModal, {
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => showUploadModel.value = $event),
        option: uploadOption,
        onSuccess: handleImportSuccess
      }, {
        help: _withCtx(() => [_hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};